import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01d69ed0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row items-start justify-between no-wrap",
  style: {"width":"calc(100% - 30px - 20px)"}
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  class: "my-popup-body",
  style: {"width":"80vw","max-width":"100vw"}
}
const _hoisted_4 = {
  class: "text-center footer-desc my-1 mt-2 d-none",
  "data-excelcolspan": "3"
}
const _hoisted_5 = {
  class: "text-center my-1 mt-2 d-none",
  "data-excelcolspan": "3"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center",
  style: {"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"}
}
const _hoisted_7 = {
  key: 0,
  src: "images/notifications/error.svg",
  alt: "Error",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_8 = {
  class: "mt-2 text-teal",
  style: {"font-size":"1.1em"}
}

import { ref, Ref, computed, watch, onUnmounted, inject } from 'vue';

import UiPopup from '@/ManualApp/Components/Popups/UiPopup.vue';
import DailyDetailTable from '../table/DailyDetailTable.vue';
import PositionsDetailPopup from './PositionsDetailPopup.vue';
import SpinLoader from '@/App/Components/SpinLoader.vue';

import ExcavatorOperation from '@/Template/ExcavatorOperation/ExcavatorOperation';

import type { IPosition } from '@/types/IPosition';

import { IPeriod } from '@/Template/Smenas';
import { getPercent } from '@/helpers/main_helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'DailyDetailPopup',
  props: {
  modelValue: Boolean,
  object: Object,
  oid: { type: String, required: true },
  name: { type: String, required: true },
  from: { type: Number, required: true },
  to: { type: Number, required: true },
  paramTitle: { type: String, required: true },
  paramKey: { type: String, required: true },
  nextParamKey: { type: String, required: true },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props

const html_to_excel_helper = window.html_to_excel_helper;




const getFullDate = inject('getFullDate') as (v: number) => string;

const TIME_SCALE_MINUTES = 30;

const model = computed({
  get: () => props.modelValue,
  set: (show) => emit('update:modelValue', show),
});

const exportToExcelButton: Ref<any> = ref(null);

const positions: Ref<any[]> = ref([]);

const responses: Ref<Map<string, any>> = ref(new Map());

const isRequest = ref(true);
const requestText = ref('');
const requestError = ref(false);

const detailOptions = ref({
  isShow: false,
  oid: '',
  name: '',
  from: 0,
  to: 0,
  paramTitle: '',
  paramKey: '',
  nextParamKey: '',
});

watch(
  () => props.modelValue,
  async (show) => {
    if (show) {
      requestReport();
    }
  },
);

onUnmounted(() => {
  responses.value.clear();
});

async function requestReport() {
  requestError.value = false;

  const { oid, from, to, paramKey, nextParamKey } = props;

  if (!oid || !from || !to || !paramKey || !nextParamKey) return;

  const key = `${oid}#${from}#${to}#${paramKey}#${nextParamKey}`;

  if (!responses.value.has(key)) {
    isRequest.value = true;
    requestText.value = 'Запрос отправлен...';

    try {
      const data = await requestPositions(oid, from, to);

      if (data && props.modelValue) {
        positions.value = data;
        isRequest.value = false;

        responses.value.set(key, data);
      }
    } catch (error) {
      requestError.value = true;
      requestText.value = 'Произошла ошибка. Попробуйте повторить запрос';
      responses.value.delete(key);
    }
  } else {
    const data = responses.value.get(key);

    if (!data) {
      isRequest.value = true;
      requestError.value = true;
      requestText.value = 'Данные не найдены. Повторите запрос';
      responses.value.delete(key);
      return;
    }

    requestText.value = 'Загружаем данные';
    isRequest.value = true;

    positions.value = data;
    isRequest.value = false;
  }
}

async function requestPositions(
  oid: string | number,
  from: number,
  to: number,
) {
  const intervals = getRequestIntervals(props.object);
  return await getReportPosition(intervals);
}

async function getReportPosition(
  intervals: {
    from: number;
    to: number;
  }[],
): Promise<IPosition[]> {
  if (!intervals.length) return [];
  let responseCount = 0;
  const promises = intervals.map((interval) => {
    return new Promise((resolve, reject) => {
      const report = new ExcavatorOperation(
        {
          settings: {
            total: true,
            isDetail: false,
            isDailyDetail: true,
          },
        },
        {
          SmenasFlag: false,
        },
      );

      report.onProcess((type: string, message: string) => {
        if (type === 'error') reject(message);
      });

      report.onSuccess((reportCalculated: any) => {
        const positions = getPositionsFromObjectPeriods(
          reportCalculated.objects[0],
        );

        responseCount++;

        const percent = getPercent(responseCount, intervals.length);

        requestText.value = `Получен ответ ${responseCount} из ${intervals.length} (${percent}%)`;

        resolve(positions);
      });

      report.getReport({
        objects: [{ id: props.oid }],
        from: interval.from,
        to: interval.to,
        time_scale_minutes: TIME_SCALE_MINUTES,
      });
    });
  });

  const positions = (await Promise.all(promises)) as IPosition[];

  return positions.flat();
}

function getRequestIntervals(obj: any) {
  const getPeriodSummByKeysValue = (period: IPeriod) => {
    const periodSummByKey = period.webSumm
      ? period.webSumm[props.paramKey]
      : false;
    return periodSummByKey ? periodSummByKey[props.nextParamKey] : 0;
  };

  const intervals: { from: number; to: number }[] = [{ from: 0, to: 0 }];
  let lastIntervalIndex = 0;

  for (const period of obj.periods) {
    const periodSummByKeysValue = getPeriodSummByKeysValue(period);
    const periodContainsData = periodSummByKeysValue > 0;

    const interval = intervals[lastIntervalIndex];
    if (periodContainsData) {
      if (interval.from === 0) {
        interval.from = period.TimeBegin;
        interval.to = period.TimeEnd;
      } else {
        interval.to = period.TimeEnd;
      }
    } else {
      if (interval.from === 0) continue;
      lastIntervalIndex++;
      intervals[lastIntervalIndex] = { from: 0, to: 0 };
    }
  }

  if (intervals[lastIntervalIndex].from === 0) {
    intervals.splice(lastIntervalIndex, 1);
  }

  return intervals;
}

function getPositionsFromObjectPeriods(obj: any) {
  if (!obj) return [];

  const positions: IPosition[] = [];

  for (const period of obj.periods) {
    const detailPositions = period.webDetail.filter(
      (position: any) => position[props.paramKey][props.nextParamKey] > 0,
    );
    positions.push(...detailPositions);
  }

  return positions;
}

function displayDetail(interval: { from: number; to: number }) {
  detailOptions.value.isShow = true;

  detailOptions.value.from = interval.from;
  detailOptions.value.to = interval.to;

  detailOptions.value.oid = props.oid;
  detailOptions.value.name = props.name;
  detailOptions.value.paramTitle = props.paramTitle;
  detailOptions.value.paramKey = props.paramKey;
  detailOptions.value.nextParamKey = props.nextParamKey;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_unref(model))
        ? (_openBlock(), _createBlock(UiPopup, {
            key: 0,
            onClose: _cache[1] || (_cache[1] = () => (model.value = false)),
            "close-button": "",
            "style-for-body": "padding: 10px; max-height: 80vh",
            class: "my-popup"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("button", {
                  class: "not-print",
                  style: {"height":"30px"},
                  onClick: _cache[0] || (_cache[0] = 
              (e) =>
                _unref(html_to_excel_helper).export(
                  e.target,
                  'daily-detail-table',
                  `${props.paramTitle} ${props.name}`,
                  'landscape',
                )
            )
                }, " Экспорт в EXCEL "),
                _createElementVNode("div", {
                  class: "text-center",
                  style: {"width":"calc(100% - 180px)"},
                  innerHTML: 
              `${props.paramTitle} ${props.name}<br>
               за период с ${_unref(getFullDate)(Number(props.from) / 1000)} 
               по ${_unref(getFullDate)(Number(props.to) / 1000)}
              `
            
                }, null, 8, _hoisted_2)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  id: "daily-detail-table",
                  style: _normalizeStyle([{"max-height":"calc(80vh - 70px)","overflow":"scroll"}, { height: isRequest.value ? '100vh' : 'auto' }])
                }, [
                  _createElementVNode("h4", _hoisted_4, _toDisplayString(props.paramTitle) + " " + _toDisplayString(props.name), 1),
                  _createElementVNode("p", _hoisted_5, " за период с " + _toDisplayString(_unref(getFullDate)(Number(props.from) / 1000)) + " по " + _toDisplayString(_unref(getFullDate)(Number(props.to) / 1000)), 1),
                  _withDirectives(_createVNode(DailyDetailTable, {
                    positions: positions.value,
                    "time-scale-minutes": TIME_SCALE_MINUTES,
                    "param-key": props.paramKey,
                    "next-param-key": props.nextParamKey,
                    onDisplayDetail: displayDetail
                  }, null, 8, ["positions", "param-key", "next-param-key"]), [
                    [_vShow, !isRequest.value]
                  ])
                ], 4),
                (isRequest.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", null, [
                        (requestError.value)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                          : _createCommentVNode("", true),
                        (!requestError.value)
                          ? (_openBlock(), _createBlock(SpinLoader, {
                              key: 1,
                              width: 50,
                              height: 50
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(requestText.value), 1),
                      (requestError.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary mt-2",
                            onClick: requestReport
                          }, " Повторить запрос "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])),
    _createVNode(PositionsDetailPopup, {
      modelValue: detailOptions.value.isShow,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((detailOptions.value.isShow) = $event)),
      oid: detailOptions.value.oid,
      name: detailOptions.value.name,
      from: detailOptions.value.from,
      to: detailOptions.value.to,
      paramTitle: detailOptions.value.paramTitle,
      paramKey: detailOptions.value.paramKey,
      nextParamKey: detailOptions.value.nextParamKey
    }, null, 8, ["modelValue", "oid", "name", "from", "to", "paramTitle", "paramKey", "nextParamKey"])
  ], 64))
}
}

})